// ids.ts — client-side ID generation for local-first rows.
//
// These IDs are used as the client_id / id field for store rows before
// they're synced to the server. They're intentionally human-readable
// (prefix identifies the entity) and time-sortable (base-36 epoch).
//
// Before this module (CO7 audit item 2026-05-13) each store defined its
// own private `newId()` function with the same shape but different prefixes,
// making it easy for the pattern to drift across files.
//
// Usage:
//   import { newClientId } from '../lib/ids';
//   const id = newClientId('inc');   // 'inc-lz1abc-xy12'
//   const id = newClientId('crew');  // 'crew-lz1abc-xy12'

/**
 * Generate a client-side local-first ID.
 *
 * @param prefix Short entity label (e.g. 'inc', 'crew', 'asgn', 'ac').
 *               Must be alphanumeric; no hyphens — the hyphen is added as
 *               the separator so the prefix is always identifiable in logs.
 * @returns `<prefix>-<base36_ms>-<4char_random>`, e.g. 'inc-lz1mpp7f-ab3c'.
 */
export function newClientId(prefix: string): string {
  return `${prefix}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 6)}`;
}
